{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "ai_sections",
  "x-feature": true,
  "x-manage-link": "/ai-sections",
  "title": "AI Sections",
  "description": "Embeddable AI question sections on client pages. Content lives in ai_sections table; this controls the feature toggle and default styling.",
  "type": "object",
  "properties": {
    "enable_mobile": {
      "ui:sectionTitle": "Mobile",
      "ui:sectionDescription": "Where AI Sections appear.",
      "ui:sectionIcon": "Smartphone",
      "type": "boolean",
      "ui:title": "Show on mobile",
      "ui:description": "Show AI Sections on mobile devices"
    }
  },
  "default": {
    "enable_mobile": true
  }
}
